<template lang="pug">
div
  h1 通用数据保护条例
  p
    | 使用本网站和使用PandaFan--由Beexio B.V.（以下简称 "公司"）提供的服务，即表示您同意遵守以下条款和条件。这些条款和条件涵盖了您的PandaFan账户目前和将来提供的所有功能，单独或统称为"服务"。
  p
    | 如本条款的中、英文版本存在差异，以英文版为准。
  h2 服务的用户
  p
    | 本服务只提供给年满13岁的个人，或已获得父母或法定监护人同意开立和维护账户的未成年人。
    br
    | 本服务只提供给个人。通过“机器人”或其他自动方法注册的账户将被终止。
    br
    | 每位用户对其使用本服务的所有行为负全部责任。
  h2 使用政策和禁止行为
  p
    | 本服务不能用于荷兰法律和您当地法律所禁止的活动。为了保护本服务不被误用、滥用或被用于伤害他人，本公司执行一些规则，这些规则平等地适用于每个用户，无论其订阅的类型如何。您特别同意不将本服务用于以下用途：
  ul
    li
      b 访问/分享/下载/上载非法内容，包括但不限于儿童色情或被认为是儿童色情的内容；
    li
      b 基于性别、性取向、宗教、民族、种族、年龄、国籍或残疾的骚扰、辱骂、侮辱、伤害、诽谤、中伤、贬低、恐吓或歧视性内容；
    li
      b 使用本服务，通过电子邮件或任何其他通信渠道发送或传输未经请求的广告或内容（例如："垃圾邮件"）。
    li
      b 试图在未经适当授权的情况下访问、探测或连接计算机设备（即任何形式的 "黑客行为"）；
    li
      b 侵害或侵犯本公司或他人的知识产权。
    li
      b 任何可能扰乱本服务的活动（例如：爬虫、创建TOR节点或其他主要用于自动化程序）。
    li
      b 参与非法活动，或通过提供指导信息为他人从事非法活动提供手段/帮助。
    li
      b 滥用无限流量。未经事先申请且获得同意，在一个计费周期（约一个月）内使用超过500GB的流量。
    li
      b 同时在线设备数量超出服务限定。
    li
      b 在非本人拥有使用权的设备上使用服务。
    li
      b 与同一屋檐下的家人之外的任何人共享账户或服务。
  p
    | 任何被发现参与上述活动、存在上述行为的用户，其账户将被立即关停，恕不另行通知。此外，如对本公司造成任何损失，您将为此负责：包括任何外部实体因上述违规行为而收取的任何费用，包括且不限于律师费和相关成本。
  h2 有限保证和责任
  p
    | 本公司对本服务的可靠性不作任何保证，尽管本公司已尽最大努力，但不保证用户数据的安全。本服务“所见即所得”，您同意不要求本公司负责、也不要求本公司赔偿因本服务的使用导致的任何损失，包括数据或利润的损失，或因本服务的失败而造成的任何损失。
  p
    | 对于您在使用本服务时访问、下载、接收或购买的任何数据、内容、服务或产品（包括软件），本公司不进行控制，也不承担任何责任。此外，如果因本服务的安全故障或漏洞而导致机密资料被无意中泄露，您同意不要求本公司承担责任或提供赔偿。
  p
    | 本公司将努力使本服务随时可用，但服务范围、速度、服务器位置和质量可能会有所不同。对于因本服务、或通信服务、或网络的中断、或性能问题而导致的数据、信息或页面丢失、无法发送、延迟或误传，本公司不承担任何责任。本公司可自行决定是否停止服务、具体流量和使用限制、是否暂停或禁用账号，或阻止任何种类及形式的使用。
  p
    | PandaFan网站可能包含其他网站的链接。但是，本公司对所链接网站的内容不承担任何责任，外部网站受其自身条款和条件以及隐私政策的约束，出现问题本公司概不负责。
  p
    | 本公司可随时对服务进行改进和变更，恕不另行通知。本公司可自行决定终止服务，而无需理由或通知。
  h2 赔偿
  p
    | 您同意本公司及任何母公司、子公司、雇员或第三方承包商对您使用本服务所产生的任何第三方索赔、要求或损害赔偿（包括合理的律师费）不承担责任。
  h2 隐私政策
  p
    a(href='/privacy-policy' title="PandaFan的隐私政策") PandaFan的隐私政策
    | 解释了本公司在您使用本服务时处理和保护您的个人数据和隐私的方式。一旦能够使用本服务，即表示您同意本条款和我们的隐私政策。
  h2 一般性支付条款
  p
    | 如果发现使用被盗信用卡等欺诈性支付行为，本公司保留立即停止服务的权利，并可能将此类案件提交给主管部门。
  h2 退款保障
  p
    | 您可以在首次购买服务后的24小时内、且数据使用量不超过100MB情况下申请取消服务，并退还服务费。不符合上述要求的退款申请可以被考虑，但由本公司全权决定。本公司仅有义务以原支付货币退款，退款将在申请后30天内处理。若要根据我们的退款保证申请退款，请通过
    a(href='/dashboard/support') 帮助中心
    | 联系我们。本退款保证条款仅适用于通过PandaFan官方网站和客户端直接订阅服务的用户（如您通过第三方处理商、中介订阅PandaFan，请参考其各自的退款政策）。
  p
    | 如果您选择使用第三方支付处理商的争议或退费机制，您将同意放弃向本公司申请上述退款的权利，且您的服务可能会被立即停止直至争议解决。此外，如果争议或扣款机制的结果导致本公司承担超过服务支付价格的金额（如争议费用），您默认授权本公司从您的账户中扣除该金额。
  p
    | 本公司也可根据账户持有人的要求，自行决定按比例退还账户持有人在服务不可用或无法使用期间支付的服务费。本公司仅有义务以原支付货币退款，退款将在申请后14天内处理。
  p
    | 支付机构收取的支付处理费将会从您的退款中扣除。
  h2
    | 推荐/促销奖励
  p
    | 推荐/促销奖励严格取决于供应情况。被推荐人必须是从未购买过本服务的新用户。
  p
    | 推荐/促销奖励不可转让、不可协商、不可退还，且不可折算为现金。
  p
    | 本公司保留取消任何推荐人/促销奖励的权利。例如，当本公司确认推荐人/用户从事：(i)欺诈、滥用促销或本服务；(ii)被推荐人已要求退款或滥用本服务。
  h2 服务条款的修改
  p
    | 在适用法律的范围内，本公司保留随时审查和更改这些条款和条件的权利。您有责任定期查看这些条款和条件。在条款变更后继续使用本服务意味着您同意这些变更。
  p
    | 本公司保留自行决定修改本服务的权利，例如增加或删除服务器的某些功能或更新软件。
  p
    | 本公司可自行决定为 "服务 "提供有限的技术支持、升级和更新。为了加强和进一步发展本服务，本公司可能会不时自动下载和安装更新和升级。作为您使用本服务的一部分，您同意接受此类更新和升级。本公司没有义务根据本协议为服务提供支持或维护。
</template>
